module.exports = __webpack_public_path__ + "img/23.7d467e72.jpg";